import PropTypes from 'prop-types'

import CSS from './flipflop.module.css'

export const FlipFlop = ({ children, theme, hero, flipped }) => {
    return (
        <section className={`${CSS.fuselage} bg-${theme} ${flipped ? CSS.flipped : ''}`}>

            <div className={CSS.image}>
                <img src={hero} alt="" />
            </div>

            <div className={`${CSS.body} p-lg formatted`}>
                {children}
            </div>

        </section>
    )
}

FlipFlop.propTypes = {
    hero: PropTypes.string.isRequired,
    decal: PropTypes.string
}